var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLlmIndicatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57416 7.73846H7.62972V7.09432H2.57416V7.73846ZM2.57416 5.80604H10.5186V5.16189H2.57416V5.80604ZM2.57416 3.87361H10.5186V3.22947H2.57416V3.87361ZM0.0463867 11.975V2.01591C0.0463867 1.71917 0.15785 1.47161 0.380776 1.27321C0.603702 1.07482 0.881035 0.975405 1.21278 0.974976H11.88C12.2122 0.974976 12.4896 1.07439 12.712 1.27321C12.9344 1.47204 13.0459 1.7196 13.0464 2.01591V8.95267C13.0464 9.24897 12.9349 9.49654 12.712 9.69536C12.4891 9.89419 12.2117 9.99338 11.88 9.99295H2.26866L0.0463867 11.975ZM1.96028 9.34881H11.88C11.9907 9.34881 12.0926 9.30759 12.1855 9.22514C12.2784 9.14269 12.3246 9.05186 12.3242 8.95267V2.01526C12.3242 1.9165 12.2779 1.82567 12.1855 1.74279C12.0931 1.65991 11.9912 1.61869 11.88 1.61912H1.21278C1.10203 1.61912 1.0002 1.66034 0.907276 1.74279C0.81435 1.82524 0.768127 1.91607 0.768609 2.01526V10.4084L1.96028 9.34881Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlmIndicatorIcon);
export default __webpack_public_path__ + "static/media/llm-indicator-icon.7b90a78f1facfc05b01f41f1acdcc250.svg";
export { ForwardRef as ReactComponent };